const EndedArrowLeft = () => (
  <>
    <path
      fill="currentColor"
      d="M4 5.5q0-.213.144-.356A.49.49 0 0 1 4.501 5q.213 0 .356.144A.49.49 0 0 1 5 5.5v13q0 .212-.144.356a.49.49 0 0 1-.357.144.48.48 0 0 1-.356-.144A.48.48 0 0 1 4 18.5zm4.021 6.498q0-.16.053-.296a.8.8 0 0 1 .184-.268l3.388-3.388a.5.5 0 0 1 .345-.15.47.47 0 0 1 .363.15.5.5 0 0 1 .16.354.5.5 0 0 1-.16.354L9.608 11.5H19.5q.212 0 .356.144a.49.49 0 0 1 .144.357q0 .212-.144.356a.49.49 0 0 1-.356.143H9.608l2.746 2.746a.5.5 0 0 1 .15.345.47.47 0 0 1-.15.363.5.5 0 0 1-.354.16.5.5 0 0 1-.354-.16l-3.388-3.389a.8.8 0 0 1-.184-.27.8.8 0 0 1-.053-.297"
    />
  </>
)
export default EndedArrowLeft
